module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "TheTablePaging"
  }, [_c('div', {
    staticClass: "TheTablePaging__pager"
  }, [(_vm.canDecrease) ? _c('i', {
    staticClass: "icon-left-open-1 TheTablePaging__button",
    on: {
      "click": _vm.previousPage
    }
  }) : _c('i', {
    staticClass: "icon-left-open-1 TheTablePaging__disabled"
  }), _vm._v(" "), _vm._v("\n        " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + "\n\n        "), _vm._v(" "), (_vm.canIncrease) ? _c('i', {
    staticClass: "icon-right-open-1 TheTablePaging__button",
    on: {
      "click": _vm.nextPage
    }
  }) : _c('i', {
    staticClass: "icon-right-open-1 TheTablePaging__disabled"
  })]), _vm._v(" "), _c('div', {
    staticClass: "TheTablePaging__count"
  }, [_vm._v(_vm._s(_vm.totalCount) + " "), _c('span', {
    staticClass: "TheTablePaging__found"
  }, [_vm._v(_vm._s(_vm.translate('TABLE__FOUND')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e0996b0a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/TheTablePaging.vue
// module id = 586
// module chunks = 1